import React, {Fragment} from 'react';
import {useSelector} from "react-redux";

const FortiusIfcBlock = ({key, template}) => {
    const documentData = useSelector(state => state.main.currentDocument.documentData);

    const nonZeroAmount = (amount) => {
        if (amount === '0.00') {
            return '-';
        } else {
            return `$${amount}`
        }
    }

    const renderIfcRow = (row, index) => {
        return (
            <>
                {/*<div className="card-header">*/}
                {/*    <h4 className="mb-0">{key}</h4>*/}
                {/*</div>*/}
                <div className="row w-100 no-gutters items-descr" key={index}>
                    <div className="col-12 col-lg-1">
                        <span className="label m-lg-0">{row.itemCode}</span><br/>
                        {/*<span style={{marginLeft: '10px'}}></span>*/}
                    </div>
                    <div className="col-12 col-lg-7">
                        <span className="label m-lg-0">{row.itemDesc}</span><br/>
                        {/*<span style={{marginLeft: '10px'}}></span>*/}
                    </div>
                    <div className="col-12 col-lg-4 pl-lg-2 items-list">
                        <div className="item d-flex ifc-fortius-cost-cell">
                            <span className="label text-default text-left d-lg-none">Charge</span>
                            <span className="label ml-auto">{nonZeroAmount(row.charge)}</span>
                        </div>
                        <div className="item d-flex ifc-fortius-cost-cell">
                            <span className="label text-default text-left d-lg-none">Rebate</span>
                            <span className="label ml-auto">{nonZeroAmount(row.fund_rebate)}</span>
                        </div>
                        <div className="item d-flex ifc-fortius-cost-cell">
                            <span className="label text-default text-left d-lg-none">Patient Cost</span>
                            <span className="label ml-auto">{nonZeroAmount(row.patient_cost)}</span>
                        </div>
                    </div>
                </div>
            </>
            );
            }

    return (
        <div className="card mb-2 mb-lg-4" key={key}>
            <div className="card-header">
                <h3 className="mb-0">Estimated</h3>
            </div>
            <div className="card-body body-small">
                <div className="row no-gutters pb-0 pb-lg-4">
                    <div className="col-12">
                        <div className="row w-100 no-gutters d-none d-lg-flex items-names mt-2 mb-3">
                            <div className="col-1">
                                <span className="label m-lg-0">Item</span>
                            </div>
                            <div className="col-7">
                                <span className="label m-lg-0">Description</span>
                            </div>
                            <div className="col-4 pl-2 items-list">
                                <div className="item d-flex ifc-fortius-cost-cell">
                                    <span className="label ml-auto">Charge</span>
                                </div>
                                <div className="item d-flex ifc-fortius-cost-cell">
                                    <span className="label ml-auto">Rebate</span>
                                </div>
                                <div className="item d-flex ifc-fortius-cost-cell">
                                    <span className="label ml-auto"><nobr>Patient Cost</nobr></span>
                                </div>
                            </div>
                        </div>

                        {documentData.estimateItems.quote_details.map(renderIfcRow)}
                    </div>

                </div>
                <div className="row no-gutters pt-3 pb-3 pb-lg-2">
                    <div className="col-12">
                        <div className="box">
                            <div className="row no-gutters justify-content-end">
                                <div className="d-flex">
                                    <span className="label text-default m-lg-0">EXCESS</span>
                                </div>
                                <div className="d-flex value">
                                    <span className="label m-lg-0">${documentData.excessTotal}</span>
                                </div>
                            </div>
                            <div className="row no-gutters justify-content-end">
                                <div className="d-flex">
                                    <span className="label text-default m-lg-0">CO-PAYMENT</span>
                                </div>
                                <div className="d-flex value">
                                    <span className="label m-lg-0">${documentData.coPayTotal}</span>
                                </div>
                            </div>
                            <div className="row no-gutters justify-content-end">
                                <div className="d-flex">
                                    <span className="label text-default m-lg-0">TOTAL ESTIMATED COST</span>
                                </div>
                                <div className="d-flex value">
                                    <span className="label m-lg-0">${documentData.patientCostTotal}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FortiusIfcBlock;